import * as React from "react";
import { Admin, Resource, CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
import {
  UserEdit,
  UserList,
  UserWorkspacesPage,
  UserConversationsPage,
  UserCarbonLinksPage,
  UserPersonalCarbonLinksPage,
  UserMessagesPage,
  UserNotificationsPage,
  UserNotificationSettingsPage,
  UserPaymentSettingsPage,
} from "./resources/users";

import UserIcon from "@mui/icons-material/Group";
import SpatialAudioOffIcon from "@mui/icons-material/SpatialAudioOff";
import ForumIcon from "@mui/icons-material/Forum";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import LanguageIcon from '@mui/icons-material/Language';
// import LockClockIcon from '@mui/icons-material/LockClock';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import InboxIcon from '@mui/icons-material/Inbox';

import authProvider, { fetchJson } from "./authProvider";
import { lightTheme } from "./layout/theme";

import "./App.css";
import Dashboard from "./dashboard/Dashboard";
import dataProvider from "./dataProvider";
// import utilitiesDataProvider from './utilitiesDataProvider';
import { WorkspaceList, WorkspaceEdit } from "./resources/workspaces";
import { MessageList } from "./resources/messages";
import { MessageStatList } from "./resources/message-statistics";
import { ChannelEdit, ChannelList } from "./resources/channels";
import UtilityList from "./resources/utilities";
import Login from "./Login";
import { ActiveUsersGraphs } from "./resources/active-users";
import { DomainList, DomainEdit, DomainCreate, DomainShow } from "./resources/domains";
// import { RetentionHoldList } from "./resources/retention-hold";
import { DataExportList, DataExportShow } from "./resources/data-export";
import Composer from "./resources/inbox-notifications/Composer";

const App = () => (
  <Admin
    dataProvider={ dataProvider(
      process.env.REACT_APP_API_BASE_URL,
      `${process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_DATA_PROVIDER_BASE}`,
      fetchJson
    )}
    loginPage={Login}
    authProvider={authProvider}
    theme={lightTheme}
    dashboard={Dashboard}
  >
    {(permissions) => (
      <>
        {permissions === "admin" ? (
          <>
            <Resource
              name="messages"
              list={MessageList}
              icon={SpatialAudioOffIcon}
            />
            <Resource
              name="users"
              list={UserList}
              edit={UserEdit}
              recordRepresentation="name"
              icon={UserIcon}
            />
            <Resource
              name="workspaces"
              list={WorkspaceList}
              edit={WorkspaceEdit}
              icon={WorkspacesIcon}
            />
            <Resource
              name="domains"
              list={DomainList}
              edit={DomainEdit}
              create={DomainCreate}
              show={DomainShow}
              icon={LanguageIcon}
            />
            <Resource
              name="channels"
              options={{
                label: "Conversations",
              }}
              list={ChannelList}
              edit={ChannelEdit}
              icon={ForumIcon}
            />
            {/* Utilities section with custom queries */}
            <Resource
              name="utilities"
              options={{
                label: 'Utilities',
              }}
              list={UtilityList}
              icon={QueryStatsIcon}
              //dataProvider={utilitiesDataProvider(fetchJson)} // Use the custom data provider
            />
            <Resource
              name="message-stats"
              options={{
                label: "Message Statistics",
              }}
              list={MessageStatList}              
              icon={SpatialAudioOffIcon}
            />
             <Resource
              name="active-users"
              options={{
                label: "Active Users",
              }}
              list={ActiveUsersGraphs}              
              icon={SpatialAudioOffIcon}
            />
            {/* <Resource
              name="retention-hold"
              options={{
                label: "Retention Hold",
              }}
              list={RetentionHoldList}
              icon={LockClockIcon}
            /> */}
            <Resource
              name="data-exporter"
              options={{
                label: "Data Exports",
              }}
              list={DataExportList}
              show={DataExportShow}
              icon={FileDownloadIcon}
            />
            <Resource
              name="inbox-notifications"
              options={{
                label: "Inbox Notifications",
              }}
              list={Composer}
              icon={InboxIcon}
            />
            <CustomRoutes>
              <Route
                path="/users/:id/workspaces"
                element={<UserWorkspacesPage />}
              />
              <Route
                path="/users/:id/conversations"
                element={<UserConversationsPage />}
              />
              <Route
                path="/users/:id/carbon-links"
                element={<UserCarbonLinksPage />}
              />
              <Route
                path="/users/:id/personal-carbon-links"
                element={<UserPersonalCarbonLinksPage />}
              />
              <Route path="/users/:id/messages" element={<UserMessagesPage />} />
              <Route
                path="/users/:id/notifications"
                element={<UserNotificationsPage />}
              />
              <Route
                path="/users/:id/notification-settings"
                element={<UserNotificationSettingsPage />}
              />
              <Route
                path="/users/:id/payment-settings"
                element={<UserPaymentSettingsPage />}
              />
            </CustomRoutes>
          </>
        ) : null}
      </>
    )}
  </Admin>
);

export default App;
